import { selectAssignment } from '@redux/experiments/selectors/index';
import type { State } from 'types/redux';

const isPaidVenue = (state: State) =>
	state.vendor.vendor?.isPaid === true &&
	state.vendor.vendor?.categoryCode === 'REC';

const hasCostBreakdown = (state: State) => {
	const amount =
		state.vendor.vendorRaw?.ai?.costBreakdown?.budgetRange?.price?.amount;
	if (!amount) return false;
	return amount.value != null || amount.min != null || amount.max != null;
};

const isEligibleForCrossCategoryLink = (state: State) =>
	isPaidVenue(state) && hasCostBreakdown(state);

export const crossCategoryLinkSelector = (state: State) => {
	if (!isEligibleForCrossCategoryLink(state)) return null;

	return selectAssignment(state, ['crossCategoryLink']);
};
